var _path, _rect, _path2, _path3, _path4, _path5, _circle, _path6, _rect2, _rect3, _rect4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReward(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 136,
    height: 108,
    viewBox: "0 0 136 108",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M130.449 62.0131C147.583 96.282 118.486 107.248 82.4725 107.248C46.4586 107.248 0.03125 94.0254 0.03125 62.0131C0.03125 30.0007 29.2263 4.04962 65.2401 4.04962C101.254 4.04962 110.083 21.282 130.449 62.0131Z",
    fill: "#EDF5FF"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 21.1133,
    y: 33.748,
    width: 92.953,
    height: 60.4465,
    rx: 3.5,
    fill: "white",
    stroke: "#F55F33",
    strokeWidth: 3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M67.8839 64.3629L20.397 33.0313L70.3317 32.6397L114.783 33.2271L67.8839 64.3629Z",
    fill: "#F55F33",
    fillOpacity: 0.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M67.4922 0.524807L20.5928 32.8355L69.94 32.248H114L67.4922 0.524807Z",
    fill: "#F55F33",
    fillOpacity: 0.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M114.196 94.5196L67.8839 63.9713L20.397 94.5196",
    stroke: "#F55F33",
    strokeWidth: 3
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M64.5902 63.2601L38.6633 45.819C37.2823 44.89 36.4541 43.3348 36.4541 41.6704V16.4909C36.4541 13.7295 38.6927 11.4909 41.4541 11.4909H91.7674C94.5288 11.4909 96.7674 13.7295 96.7674 16.4909V42.5531C96.7674 44.2098 95.9468 45.759 94.5761 46.6896L70.1897 63.248C68.5007 64.3948 66.2841 64.3996 64.5902 63.2601Z",
    fill: "#4F5BD5"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 67.5903,
    cy: 63.775,
    r: 8.81201,
    fill: "#F9BA0F"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M67.771 68.5383L67.3896 68.4315L66.9318 68.1874L66.5961 67.9738L66.2451 67.7296L65.7569 67.4244L65.3144 67.1193L64.7803 66.7073L63.9716 65.9901L63.468 65.5171L63.0713 65.1203L62.7203 64.6626L62.4304 64.1285L62.2778 63.8844L62.1863 63.686L62.049 63.1977L61.9574 62.8773L61.9116 62.6637V62.0838V61.5803L62.0337 61.2293L62.3389 60.6342L62.7661 60.0086L63.2239 59.6424L63.7427 59.2457L64.2462 59.0168L64.7803 58.8795H65.3906L65.7721 58.9405L66.2299 59.0778L66.7182 59.2457L67.0844 59.4288L67.4353 59.6424L67.6795 59.856L67.8016 59.9476L67.8931 59.856L68.122 59.6424L68.4119 59.4288L68.7171 59.2457L69.1291 59.0778L69.5716 58.9405L70.0446 58.8795H70.6244L71.2348 59.0168L71.8299 59.2457L72.4403 59.6424L72.8217 60.0086L73.2337 60.5274L73.5389 61.2293L73.661 61.7481V62.5111V62.7705L73.4016 63.625L72.898 64.571L72.4708 65.1356L71.7536 65.8985L70.8686 66.6462L68.6561 68.1874L68.1983 68.4315L67.771 68.5383Z",
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 51.7285,
    y: 22.8486,
    width: 29.3734,
    height: 3.5248,
    rx: 1.7624,
    fill: "white"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 51.7285,
    y: 39.2976,
    width: 29.3734,
    height: 3.5248,
    rx: 1.7624,
    fill: "white"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 51.7285,
    y: 31.0731,
    width: 29.3734,
    height: 3.5248,
    rx: 1.7624,
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReward);
export default __webpack_public_path__ + "static/media/reward.70e11712714f32b5e98338bbbbd91cc8.svg";
export { ForwardRef as ReactComponent };